module.exports = __webpack_public_path__ + "static/img/case_detail_14_1.a2900fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_14_1.png
// module id = Mwbi
// module chunks = 34